import { JOURNAL_REG_EXP } from '@/constants/journal'

const { isCorrectArticleSlug, isAbsoluteArticleLink, getArticleSlug, youtube } = JOURNAL_REG_EXP

export const handleYoutubeLink = (fullLink?: string) => {
  // TODO: оставлено временно, для старых статей
  if (!fullLink) return undefined

  return fullLink.match(youtube)?.[1] || fullLink
}

export const handleArticleLink = (url?: string) => {
  if (!url) return undefined

  if (isAbsoluteArticleLink.test(url)) return url.match(getArticleSlug)?.[0]

  if (isCorrectArticleSlug.test(url)) return url

  return undefined
}
